// extracted by mini-css-extract-plugin
export default {"wrapper":"LogIn_wrapper__fdzTb","container":"LogIn_container__nmm5-","form":"LogIn_form__lOIxg","button":"LogIn_button__ew28a","account":"LogIn_account__rfisu"};